export default {"src":"/_next/static/media/trending.8fa0b540.gif","height":36,"width":36,"blurWidth":0,"blurHeight":0};